













































































import Vue from "vue";
import Component from "vue-class-component";
import CountryBox from "./components/Lists/CountryBox.vue";
import navbar from "@/views/system/Navbar.vue";
import LoadingSpinner from "@/views/system/LoadingSpinner.vue";
import { UserStore } from "./store";
import SessionTimeout from "@/components/SessionTimout.vue";

@Component({
  components: {
    navbar,
    LoadingSpinner,
    SessionTimeout
  }
})
export default class App extends Vue {
  mounted() {
    const companyName = UserStore.companyName;
    document.title = companyName
      ? companyName + " | Client Portal"
      : "Client Portal";
  }
}
